export default __webpack_public_path__ + "static/Blitz3 01F33720-b557821524a29f596ba260c9c2dc1e7f.jpg";